import React from 'react';
import { observer } from 'mobx-react-lite';
import ModalProvider from '../modal-provider';
const TableContext = React.createContext({
    tableStore: {},
    dataSet: {},
    indentSize: 15,
    rowHeight: 30,
});
const TableContextProvider = observer((props) => {
    const { children, tableStore, dataSet, ...other } = props;
    const value = {
        ...other,
        dataSet,
        tableStore,
        border: tableStore.border,
        columnEditorBorder: tableStore.columnEditorBorder,
        rowHeight: tableStore.rowHeight,
        aggregation: tableStore.aggregation,
        inlineEdit: tableStore.inlineEdit,
        expandIconAsCell: tableStore.expandIconAsCell,
        canTreeLoadData: tableStore.canTreeLoadData,
        parityRow: tableStore.parityRow,
        checkField: dataSet.props.checkField,
    };
    return (React.createElement(TableContext.Provider, { value: value }, tableStore.customizable ? (React.createElement(ModalProvider, null, children)) : children));
});
TableContextProvider.displayName = 'TableContextProvider';
export default TableContext;
export { TableContextProvider, };
